var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.11914C6.88632 1.11914 1.12 6.88546 1.12 13.9991C1.12 21.1128 6.88632 26.8791 14 26.8791C21.1137 26.8791 26.88 21.1128 26.88 13.9991C26.88 6.88546 21.1137 1.11914 14 1.11914ZM14 6.15914C14.9279 6.15914 15.68 6.91122 15.68 7.83914C15.68 8.76706 14.9279 9.51914 14 9.51914C13.0721 9.51914 12.32 8.76706 12.32 7.83914C12.32 6.91122 13.0721 6.15914 14 6.15914ZM16.24 21.2791H15.12H12.88H11.76V20.1591H12.88V12.8791H11.76V11.7591H12.88H15.12V12.8791V20.1591H16.24V21.2791Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconWhite);
export default __webpack_public_path__ + "static/media/info_icon_white.dc914c28f3f58f75b6d763369e43d567.svg";
export { ForwardRef as ReactComponent };